<template>
  <v-main class="customer-detail-page">
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">用户</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="ml-4" outlined small @click="onChangeBalance">增减余额</v-btn>
    </v-app-bar>
    <v-container fluid>
      <div class="px-4 pb-8">
        <EquityGroupList :equityGroupList="equityGroupList" :getBalance="getBalance"
          :getBalanceDetailLink="getBalanceDetailLink" />
      </div>
      <v-simple-table v-if="customer">
        <template v-slot:default>
          <thead></thead>
          <tbody>
            <tr v-for="(value, key) in customerTable" :key="key">
              <td>{{ key }}</td>
              <td class="value">
                <pre class="value-content">{{ jsonFormat(value) }}</pre>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <CustomerBalanceDialog v-model="showDialog" :customerId="id" @success="onChangeBalanceSuccess" />
    </v-container>
  </v-main>
</template>

<script>
import _ from 'lodash'
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { homeStore } from '@/store/home'
import { customerStore } from '@/store/customer'
import EquityGroupList from '@/components/EquityGroupList.vue'
import CustomerBalanceDialog from './CustomerBalanceDialog.vue'
import { equityStore } from '@/store/equity'

export default {
  name: 'CustomerDetailPage',
  components: { AppbarBackIcon, EquityGroupList, CustomerBalanceDialog },
  data() {
    return {
      showDialog: false,
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null
    },
    customer() {
      return customerStore.get(this.id)
    },
    hasDetail() {
      return !_.isNil(this.customer) && !_.isNil(this.customer.balance_s)
    },
    customerTable() {
      let result = Object.assign({}, this.customer || {})
      return result
    },
    equityGroupList() {
      return equityStore.groupList
    },
  },
  async mounted() {
    await homeStore.doLoad()
    if (this.id && !this.hasDetail) {
      await customerStore.doInfo({
        customer_id: this.id,
        include_balance: true,
      })
    }
    await equityStore.doLoad()
  },
  methods: {
    jsonFormat(data) {
      return JSON.stringify(data, null, 2)
    },
    getBalance(equityId) {
      let balanceList = this.customer.balance_s || []
      return balanceList.find(x => x.equity_id === equityId)
    },
    getBalanceDetailLink(equityId) {
      return {
        name: 'CustomerBalanceDetailPage',
        params: this.$route.params,
        query: {
          customer: this.id,
          equity: equityId,
        },
        hash: this.$route.hash,
      }
    },
    onChangeBalance() {
      this.showDialog = true
    },
    async onChangeBalanceSuccess() {
      await customerStore.doInfo({
        customer_id: this.id,
        include_balance: true,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.customer-detail-page {
  .balance-logs {
    font-size: 12px;
    white-space: break-spaces;
    word-break: break-all;
  }

  .value {
    padding: 0;
  }

  .value-content {
    padding: 0 16px;
    max-height: 12 * 21px;
    overflow-y: scroll;
  }
}
</style>
